import { render } from "./EventParticipationAssessmentStateRenderer.vue?vue&type=template&id=060e0df2&ts=true"
import script from "./EventParticipationAssessmentStateRenderer.vue?vue&type=script&lang=ts"
export * from "./EventParticipationAssessmentStateRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__